'use strict';
import { connect } from 'react-redux';
import 
{
	programsSelector,
	programTeasersSelector
} from '../../selectors';

var React = require('react');
var Sticky = require('../elements/Sticky.jsx');
var ProgramCategoryNavigation = require('./ProgramCategoryNavigation.jsx');
var ProgramFilterNavigation = require('./ProgramFilterNavigation.jsx');
var ProgramGroup = require('./ProgramGroup.jsx');
var ProgramGroupNavigation = require('./ProgramGroupNavigation.jsx');
var ProgramListTeasers = require('./ProgramListTeasers.jsx');
var LoadAction = require('../../actions').loadProgramListPage;
var executeLoadActions = require('../../addons/executeLoadActions');

class ProgramListHandler extends React.Component {
	render() {
		const {list, categories, filters, teasers, displayCategories} = this.props;
		return (
			<section className="svtse_section svtse_section--white">

				<div className="svtse_program-list">
					<h1 className="svtse_program-list__header">Program</h1>

					{/* Teasers */}
					<ProgramListTeasers model={teasers}/>

					{/* Navigation*/}
					<ProgramGroupNavigation model={list} tabIndex="-1" id="program-list-navigation"/>

					{/* Filter & category */}
					<div className="svtse_program-list-filters">
						<div className="svtse_program-list-filters__show">
							<h3 className="svtse_program-list-filters__headline">Visa</h3>
							<ProgramFilterNavigation filters={filters}/>
						</div>
						<div className="svtse_program-list-filters__categories">
							<h3 className="svtse_program-list-filters__headline">Kategorier</h3>
							<ProgramCategoryNavigation categories={categories}/>
						</div>
						<div className="svtse_program-list-sticky">
							<Sticky>
								<span className="svt_icon svt_icon--arrow-up"> </span>
								<a href="#navigation_a-o" className="svtse_program-list-sticky__link">
									Till navigationen
								</a>
							</Sticky>
						</div>
				</div>


					{/* Content */}
					<div className="svtse_program-list__content">
					{list.map(function(value, key){
							return (
								<ProgramGroup
									key={key}
									name={key}
									model={value}
									showCategories={displayCategories}
								/>
							);
					})}
					</div>



				</div>
			</section>
		);
	}
}

// Define our route load actions
ProgramListHandler.handlerActions = [ LoadAction ];
ProgramListHandler.contextTypes = {
	store: React.PropTypes.object.isRequired
};

function select(state) {
	const programlist = programsSelector(state);
	return {
			list: programlist.get('programs'),
			categories: programlist.get('categories'),
			filters: programlist.get('filters'),
			displayCategories: programlist.get('highlite'),
			teasers: programTeasersSelector(state)
	};
}
export default connect(select)(executeLoadActions(ProgramListHandler));



/** WEBPACK FOOTER **
 ** ./app/components/ProgramListHandler/index.js
 **/